import React, { useMemo } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const PeriodSelector = ({ value, onChange, allowCustomRange = true }) => {
  const mode = value?.mode || "month";

const selectedMonth = useMemo(() => {
  if (!value?.month || !value?.year) return null;

  return new Date(
    Number(value.year),
    Number(value.month) - 1,
    1
  );
}, [value?.month, value?.year]);

  const handleModeChange = (newMode) => {
    onChange({
  mode: newMode,

  month: newMode === "month"
    ? value?.month || ""
    : "",

  year: newMode === "month"
    ? value?.year || ""
    : "",

  startDate: newMode === "custom"
    ? value?.startDate || ""
    : "",

  endDate: newMode === "custom"
    ? value?.endDate || ""
    : "",
});
  };

  const handleMonthPickerChange = (date) => {
 onChange({
  ...value,
  mode: "month",

  month: date
    ? String(date.getMonth() + 1).padStart(2, "0")
    : "",

  year: date
    ? String(date.getFullYear())
    : "",
});
  };

  const handleStartDateChange = (e) => {
    onChange({
      ...value,
      startDate: e.target.value,
    });
  };

  const handleEndDateChange = (e) => {
    onChange({
      ...value,
      endDate: e.target.value,
    });
  };

  return (
    <div className="period-selector">
      {/* Toggle Mode */}
      <div className="period-mode-toggle">
        <button
          className={`mode-button ${mode === "month" ? "active" : ""}`}
          onClick={() => handleModeChange("month")}
          type="button"
        >
          Mes
        </button>
        {allowCustomRange && (
          <button
            className={`mode-button ${mode === "custom" ? "active" : ""}`}
            onClick={() => handleModeChange("custom")}
            type="button"
          >
            Rango personalizado
          </button>
        )}
      </div>

      {/* Month Mode */}
      {mode === "month" && (
        <div className="period-month-mode">
          <DatePicker
            selected={selectedMonth}
            onChange={handleMonthPickerChange}
            dateFormat="MM/yyyy"
            showMonthYearPicker
            placeholderText="Seleccionar mes..."
            className="field-select"
          />
          {value?.month && value?.year && (
            <div className="selected-value">
                {value.month}-{value.year}
            </div>
            )}
        </div>
      )}

      {/* Custom Range Mode */}
      {mode === "custom" && allowCustomRange && (
        <div className="period-custom-mode">
          <div className="date-input-group">
            <label className="date-label">Fecha inicio</label>
            <input
              type="date"
              className="date-input"
              value={value?.startDate || ""}
              onChange={handleStartDateChange}
            />
          </div>
          <div className="date-input-group">
            <label className="date-label">Fecha fin</label>
            <input
              type="date"
              className="date-input"
              value={value?.endDate || ""}
              onChange={handleEndDateChange}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default PeriodSelector;
